import { render, staticRenderFns } from "./AsignacionTurno.vue?vue&type=template&id=77c719f0&scoped=true"
import script from "./AsignacionTurno.vue?vue&type=script&lang=js"
export * from "./AsignacionTurno.vue?vue&type=script&lang=js"
import style0 from "./AsignacionTurno.vue?vue&type=style&index=0&id=77c719f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c719f0",
  null
  
)

export default component.exports